module.exports = __webpack_public_path__ + "img/116020.32733912.png";